import "./index.css";

export const StaffCapsule = ({ text }) => (
  <span className="capsule">{text ?? "STAFF"}</span>
);
